module.exports = __webpack_public_path__ + "img/b_Mukoleks_right.05d97db8.jpeg";